export default __webpack_public_path__ + "static/media/studentsRegistered.c50c8508.svg";